import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { hotel_facts } from '../../common/facts';
import { top_amenities } from '../../common/top_amenities';

const facts = hotel_facts.en;

export const TopAmenities = ({ data }) => {

    const [amenities, setAmenities] = useState([]);

    useEffect(() => {
        let arr = top_amenities
            .filter(e => {
                if (data.facts && data.facts[e.fact]) {
                    if (typeof e.value === 'string') {
                        if (typeof data.facts[e.fact] === 'object' && data.facts[e.fact][e.value]) {
                            return true;
                        } else return false;
                    } else return true;
                }
                return false;
            })
            .map(e => ({
                text: facts.facts[e.fact].label,
                icon: e.icon
            }));

        setAmenities(arr.length < 8 ? arr.splice(0, 4) : arr.splice(0, 8));

    }, [data]);

    return (
        <Row id="top-amenities" gutter={[24, 24]}>
            {
                amenities
                    .map(({text, icon}) => (
                        <Col
                            xs={12} md={6}
                            className='d-flex align-items-center'
                            key={text}
                        >
                            <span className="material-symbols-outlined me-2 fs-3"
                                
                            >{icon}</span>
                            <h6 className='position-relative m-0'>{text}</h6>
                        </Col>
                    ))
            }
        </Row>
    );
}